export const symptoms = [
    // A
    "Abnormal coloration (e.g., pale, darkened)",
    "Abnormal swimming patterns (circular, vertical, or spiraling movement)",
    "Anorexia (refusal to feed)",
    "Anus protrusion or reddening",
    
    // B
    "Bloating (swollen belly)",
    "Bleeding from gills, fins, or skin",
    "Body deformities (e.g., S-shaped or curved spine)",
    "Buoyancy issues (floating or sinking abnormally)",
    "Bulging eyes (exophthalmia)",
    
    // C
    "Cyst formation (on skin, fins, or gills)",
    "Cloudy eyes",
    "Color loss (fading pigment, albino-like appearance)",
    "Convulsions or twitching",
    "Cutaneous nodules or lumps",
    
    // D
    "Decreased growth rate",
    "Dehydrated appearance (in shrimp)",
    "Detached or frayed fins",
    "Discoloration of internal organs (seen during necropsy)",
    "Distended abdomen",
    "Dorsal fin collapse or rotting",
    
    // E
    "Erratic swimming",
    "Eye opacity",
    "Excessive mucus on skin or gills",
    "External parasites visible on skin or fins",
    
    // F
    "Fading scales",
    "Feces trailing behind (indicates internal infection or indigestion)",
    "Fin rot or erosion",
    "Flashing (rubbing body against pond walls, nets, or objects)",
    "Floating at the surface",
    
    // G
    "Gas bubble disease (tiny bubbles under skin)",
    "Gaping mouth (open mouth breathing constantly)",
    "Gill bleeding",
    "Gill necrosis (dead tissue)",
    "Gill pallor or redness",
    "Gulping at surface (indicating oxygen depletion or gill disease)",
    
    // H
    "Hemorrhages under skin or at fin base",
    "Head erosion (common in chronic infections)",
    "Hunched back (spinal deformation)",
    
    // I
    "Internal fluid accumulation (ascites)",
    "Inflammation at base of fins or tail",
    "Inactive behavior (hiding, no movement)",
    
    // J/K/L
    "Jumping out of water (sudden escape behavior due to irritation)",
    "Lethargy",
    "Lesions on skin or fins",
    "Loss of scales",
    "Loss of equilibrium or balance",
    
    // M
    "Mouth lesions or sores",
    "Mouth staying open (difficulty closing)",
    "Mucus secretion increase (skin or gills)",
    
    // N
    "Necrosis of fins or skin",
    "Nipping at each other (aggression due to stress)",
    
    // O
    "Open ulcers or sores",
    "Opaque cornea",
    "Operculum damage (gill cover eroded)",
    
    // P
    "Pineconing (raised scales due to fluid buildup in body – \"dropsy\")",
    "Pop-eye (eye bulging out)",
    "Protruding scales",
    "Pus discharge from wounds",
    
    // R
    "Rapid gill movement (hyperventilation)",
    "Red sores or streaks on fins and tail",
    "Reduced feeding response",
    "Rotting fins or skin",
    
    // S
    "Scale loss",
    "Skin flaking or sloughing",
    "Spinal bending (lordosis or scoliosis)",
    "Sunken eyes",
    "Swim bladder disorder (can't maintain buoyancy)",
    "Swollen or protruding belly",
    "Surface gasping (oxygen stress or gill damage)",
    
    // T
    "Tail rot",
    "Twitching or muscle spasms",
    
    // U
    "Ulceration on skin or body",
    "Uncoordinated movements",
    
    // V/W/X/Y/Z
    "Vertical swimming",
    "White patches on skin or gills (fungal or parasitic)",
    "White feces (indicative of internal parasites or nutritional imbalance)",
    "White spots (e.g., Ich caused by Ichthyophthirius multifiliis)",
    "Yellowish mucus discharge",
    "Zoning (fish cluster at pond corners, indicating discomfort)"
];